import { useState } from 'react'
import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import moment from 'moment-timezone'
import { Alert, Button, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import DateTimePicker from './DateTimePicker'

const UpdateUnverifiedLegacyAgreementDates = gql`
mutation UpdateUnverifiedLegacyAgreementDates($input: UpdateUnverifiedLegacyAgreementDatesMutationInput!){
    updateUnverifiedLegacyAgreementDates(input: $input){
        ok
        errors{
            field
            messages
        }
    }
}`

const UpdateAgreementDates = ({ rental, open, handleClose, refetchQuery }) => {
    const isUnverified = rental.agreementType?.toLowerCase() === "fast track bc unverified legacy"
    const [input, setInput] = useState({ startDate: rental.startDate, endDate: rental.endDate })
    const [startDateError, setStartDateError] = useState(null)
    const [endDateError, setEndDateError] = useState(null)
    const [error, setError] = useState(null)
    const [updateDates, { loading }] = useMutation(UpdateUnverifiedLegacyAgreementDates)

    const updateInput = (name, value) => setInput(prev => ({ ...prev, [name]: value }))

    const save = () => {
        if (!input.startDate || !input.endDate) {
            setError("Please provide both start and end date")
            return
        }
        if (!moment(input.endDate).isAfter(moment(input.startDate))) {
            setError("End date must be after start date")
            return
        }
        setError(null)
        updateDates({ variables: { input: { agreement: rental.id, startDate: input.startDate, endDate: input.endDate } } })
            .then(({ data }) => {
                if (data?.updateUnverifiedLegacyAgreementDates?.ok) {
                    refetchQuery()
                    handleClose()
                } else {
                    setError(data?.updateUnverifiedLegacyAgreementDates?.errors?.[0]?.messages?.join(", ") || "An error has occurred. Please contact admin.")
                }
            })
            .catch((err) => setError(err.message || "An error has occurred. Please contact admin."))
    }

    const driverId = rental.driver?.id || null
    const validationError = error || startDateError || endDateError

    return (
        <Modal isOpen={open} toggle={loading ? undefined : handleClose} size="lg">
            <ModalHeader>{isUnverified ? "Verify Rental Dates" : "Edit Rental Dates"}</ModalHeader>
            <ModalBody>
                {validationError && <Alert color="danger">{validationError}</Alert>}
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="agreementStartDate">Start Date</Label>
                            <DateTimePicker id="agreementStartDate" name="startDate" value={rental.startDate} updateInput={updateInput} setError={setStartDateError} driverId={driverId} />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="agreementEndDate">End Date</Label>
                            <DateTimePicker id="agreementEndDate" name="endDate" value={rental.endDate} updateInput={updateInput} setError={setEndDateError} driverId={driverId} />
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button outline color="secondary" onClick={handleClose} disabled={loading}>Cancel</Button>
                <Button color="primary" onClick={save} disabled={loading || !!startDateError || !!endDateError}>
                    {loading ? "Saving..." : "Save Dates"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default UpdateAgreementDates
